import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

export const PRODUCT_ZOOM_KEY = 'fullscreen-mode';

export const useProductZoomOpenedState = () => {
  return useOpenedStateManager(PRODUCT_ZOOM_KEY);
};
